import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const SearchProductsContainer = styled(Box)`
  // border-radius: ${theme.attributes.borderRadius.secondary};
  //border: 1px solid ${theme.colors.borderLow};
  // background: ${theme.colors.surfaceItemBackground};
  // box-shadow: ${theme.attributes.boxShadow.selectFieldPaper};
  height: 100%;
  padding: ${theme.spacing.xSmall}px;
  overflow-y: hidden;
`

export const AutocompleteContainer = styled(Box)`
  position: relative;
  width: 100%;
`

export const NoIntegrationLogo = styled(Box)`
  border: 1px solid ${theme.colors.legacy342f322};
  box-shadow: ${theme.attributes.boxShadow.overallScoreWrapper};
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  min-height: 24px !important;
  background: ${theme.baseColors.greyscale[80]};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1280px) {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 1600px) and (max-height: 1079px) {
    width: 22px;
    height: 22px;
  }

  .no-integration-logo-letter {
    color: #342f32;
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: normal;
  }
`

export const NoResultsList = styled('ul')<{ hideborder?: string; length: number }>`
  box-sizing: border-box;
  margin-top: 0;
  padding: 0;

  &.search-vendors-empty-text-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    .search-vendors-empty-text {
      overflow: hidden;
      color: ${theme.colors.textSecondary};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;

      .here-text {
        color: ${theme.colors.cta};
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        cursor: pointer;
        //padding: 0 4px;
      }
    }
  }
`

export const ResultListItem = styled('li')<{ iscustomvendor?: string }>`
  cursor: default;
  border-radius: ${theme.attributes.borderRadius.small};

  .list-item-wrapper {
    display: flex;
    align-items: center;
    cursor: default;
    list-style: none;
    background: transparent;
    height: 40px;
    border-radius: ${theme.attributes.borderRadius.small};
    gap: ${theme.spacing.small}px;
    padding-left: 8px;
  }

  .option-text {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 22px;
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 274px;

    &.text-disabled {
      color: ${theme.baseColors.greyscale[50]};
    }
  }

  &:hover {
    cursor: pointer;
    background: ${theme.colors.menuItemHover};
  }

  ${({ iscustomvendor }) =>
    iscustomvendor &&
    iscustomvendor === 'true' &&
    `    
      &:hover {
        cursor: pointer;
        background: ${theme.colors.legacyAlpha7} !important;  
  
        &:last-of-type {
          box-shadow: none;
          background: transparent;
        }
      }
    
      &:last-of-type {
        background: transparent;
        
        &:hover {
          background: ${theme.colors.legacyAlpha7} !important;
        }
      }
    `}

  img {
    min-width: 24px !important;
    width: 24px !important;
    height: 24px !important;
    object-fit: cover !important;
  }
`

export const ResultsList = styled('ul')<{ hideborder?: string; items: number }>`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 0;
  margin: 8px 0 0 0;
  outline: 0;
  border-radius: ${theme.attributes.borderRadius.secondary};
  height: ${({ items }) => (items && items <= 5 ? `${40 * items}px` : !items ? 0 : '200px')};
  max-height: ${({ items }) => (items && items <= 5 ? `${40 * items}px` : !items ? 0 : '200px')};
  overflow-y: auto;
  height: auto;

  .no-options-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: ${theme.spacing.xSmall}px;

    .no-optons-text {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
    }
  }

  ${({ hideborder }) =>
    hideborder &&
    hideborder === 'true' &&
    `
      border-radius: 0 0 ${theme.attributes.borderRadius.secondary} ${theme.attributes.borderRadius.secondary};
  `};

  ${({ items }) =>
    items > 5 &&
    `
    overflow-y: scroll;
  `};

  ::-webkit-scrollbar {
    width: 6px !important;
    background: ${theme.colors.controlBorder};
  }

  ::-webkit-scrollbar-track {
    width: 6px !important;
    background: ${theme.colors.controlBorder};
    border-radius: ${theme.attributes.borderRadius.small};
  }

  ::-webkit-scrollbar-thumb {
    width: 6px !important;
    background: ${theme.colors.borderMedium};
    border-radius: ${theme.attributes.borderRadius.secondary};
  }
`

export const SearchVendorsInputWrapper = styled(Box)<{ hasinputvalue?: string }>`
  width: 100%;

  & .MuiFormControl-root {
    width: 100%;
    border-radius: 8px;
    border: 0;
    outline: 0;
    height: 40px;

    & .MuiInputLabel-root {
      color: ${theme.colors.calendarDay};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 24px;
      letter-spacing: 0.5px;

      &.MuiInputLabel-shrink {
        font-family: ${theme.typography.fontFamily.primary};

        &.Mui-focused {
          color: ${theme.colors.cta};
          font-size: ${theme.typography.fontSize.medium};
          letter-spacing: 0.4px;
        }
      }
    }

    & .MuiOutlinedInput-root {
      height: 40px;
      padding: 0 ${theme.spacing.small}px;
      border-radius: 8px;
      border: 1px solid ${theme.colors.legacy2921282};
      background: ${theme.colors.surfaceContainerBackground};

      color: ${theme.colors.foreground};
      text-align: center;
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.1px;

      .MuiInputAdornment-root.MuiInputAdornment-positionEnd {
        &:hover {
          cursor: ${({ hasinputvalue }) => (hasinputvalue && hasinputvalue === 'false' ? 'default' : 'pointer')};

          svg {
            path {
              fill: ${({ hasinputvalue }) =>
                hasinputvalue && hasinputvalue === 'false' ? theme.colors.textSecondaryLow : theme.colors.foreground};
            }
          }
        }
      }

      input {
        padding-left: 0;
        margin-left: -2px;
      }

      fieldset {
        border: 0;
        outline: 0;

        span {
          font-size: 8.5px;
        }
      }

      &:hover fieldset {
        border-color: ${theme.colors.controlBorder};
      }

      &.Mui-focused {
        border: 1px solid transparent;

        & fieldset {
          border: 2px solid ${theme.colors.cta};
        }
      }
    }

    & .search-vendors-loading-indicator {
      color: ${theme.colors.cta};
    }
  }
`

export const SearchVendorsResultsContainer = styled('div')`
  border-radius: ${theme.attributes.borderRadius.secondary};
  z-index: 1;
  margin-top: ${theme.spacing.xSmall}px;

  .search-vendors-results-text {
    color: ${theme.colors.textSecondary};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    padding-left: 8px;
  }

  .search-vendors-loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 200px;

    .search-vendors-loading-progress {
      color: ${theme.colors.cta};
    }
  }

  .search-vendors-empty-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${theme.spacing.medium}px;

    .search-vendors-empty-title {
      overflow: hidden;
      color: ${theme.colors.foreground};
      text-overflow: ellipsis;
      font-family: Quicksand, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
    }
  }
`
